import { RouteObject } from 'react-router-dom'
import PoliticasPendentesPage from '@/pages/produtos/PoliticasPendentesPage'
import SomenteBackoffice from '@/router/SomenteBackoffice'

/**
 * Políticas por Produto, onda P6 (AN-PP6 §2.4/§8 — DEV-PP6-F1): fila de aprovação das políticas do produto.
 *
 * Back-office (OPERADOR+ no backend); o consultor que chegar pela URL volta ao dashboard. Rota estática irmã de
 * `produtos/:id` — o roteador prefere o segmento estático, então `politicas-pendentes` nunca vira um id.
 */
const rotasPp6: RouteObject[] = [
  {
    path: 'produtos/politicas-pendentes',
    element: (
      <SomenteBackoffice>
        <PoliticasPendentesPage />
      </SomenteBackoffice>
    ),
  },
]

export default rotasPp6
